// @ts-nocheck
import PropTypes from 'prop-types'
import Switch from 'react-switch'
import { get } from 'lodash'
import { FormFieldLayout } from '../../generic'
import { colors } from '@lmc/common/constants'
import AnimateHeight from 'react-animate-height'

export default function SwitchField({
  errors,
  formKey,
  onChange,
  options,
  values,
  ...props
}) {
  const error = get(errors, formKey)
  const value = get(values, formKey)

  return (
    <FormFieldLayout hasError={!!error} {...props}>
      <div style={styles.wrapper}>
        {options && <span style={styles.offLabel}>{options.off.label}</span>}
        <div style={{ alignSelf: 'center' }}>
          <Switch
            onChange={() =>
              onChange({ key: formKey, value: getChangeValue(options, value) })
            }
            checked={isChecked(options, value)}
            onColor={getColor(options, 'on')}
            offColor={getColor(options, 'off')}
            handleDiameter={16}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={50}
          />
        </div>
        {options && <span style={styles.onLabel}>{options.on.label}</span>}
      </div>
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const isChecked = (options, currentValue) => {
  if (!options) return !!currentValue
  return currentValue === options.on.value
}

const getColor = (options, state) => {
  const defaultColor = state === 'on' ? colors.successgreen : colors.grey
  if (!options || !options[state] || !options[state].color) {
    return defaultColor
  }
  return options[state].color || defaultColor
}

const getChangeValue = (options, value) => {
  if (!options) return !value
  return value === options.on.value ? options.off.value : options.on.value
}

const styles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5,
  },
  offLabel: {
    display: 'block',
    alignSelf: 'center',
    marginRight: 10,
  },
  onLabel: {
    display: 'block',
    alignSelf: 'center',
    marginLeft: 10,
  },
  wrapper: {
    display: 'flex',
  },
}

SwitchField.propTypes = {
  options: PropTypes.shape({
    on: PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
    off: PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    }),
  }),
}
